import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid } from 'semantic-ui-react';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { useStore } from '../../../app/stores/store';
import MediaAssetFilters from './MediaAssetFilters';
import MediaAssetList from './MediaAssetList';
import '../../../app/common/MediaQuery/responsive-asset-list.css';
import UnauthorizedMessage from '../../UnauthorizedMessage';

export default observer(function MediaAssetDashboard() {
  const { activityStore, userStore, dashboardStore, commonStore } = useStore();
  // const { loadActivities, activityRegistry } = activityStore;
  const isFirstAPI = useRef(false);

  useEffect(() => {
    dashboardStore.updateCountOrderMenu(userStore?.user?.id || '');
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    isFirstAPI.current = true;
  }, []);
  useEffect(() => {
    if (isFirstAPI.current) {
      isFirstAPI.current = false;
      return;
    }
    if (
      !activityStore?.filterItem
        ?.toLocaleLowerCase()
        ?.includes(activityStore.Filter.toLocaleLowerCase())
    ) {
      activityStore.filterItem = '';
      activityStore.FilterById = '';
    }
    let timer = setTimeout(() => {
      activityStore.currentPage = 1;
      activityStore.searchAndItemGroupsAndFilter();
      activityStore.itemGroupIdAPI();
    }, 700);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [activityStore.Filter]);

  // useEffect(() => {
  //   if (workLevelRegistryAll.size <= 1) loadWorkLevels();
  // }, [workLevelRegistryAll.size, loadWorkLevels]);

  if (activityStore.loadingInitial)
    return <LoadingComponent content="Loading activities..." />;

  return (
    <>
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        commonStore.filterModeOne?.includes('AILB01') && (
          <Grid doubling columns={2} className="media-asset-container">
            <Grid.Column
              width="3"
              className="media-asset-dashboard"
              style={{ bottom: '10px' }}
            >
              <MediaAssetFilters />
            </Grid.Column>
            <Grid.Column
              width="13"
              style={{ maxHeight: '100vh', bottom: '35px' }}
            >
              <MediaAssetList />
            </Grid.Column>
          </Grid>
        )}

      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('AILB01') && (
          <UnauthorizedMessage />
        )}
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <LoadingComponent />
      )}
    </>
  );
});
